import { GetAllDevicesResponse } from '../types';
import { AppEntityRequest } from './entities';
import { DevicesUpdatable } from './updatable';

export const UPDATE_DEVICES_REQUEST_SUCCESS = 'UPDATE_DEVICES_REQUEST_SUCCESS';

export interface UpdateDevicesRequest extends AppEntityRequest {
    deviceIds: string[];
}

export interface EnableDisableDevicesRequest extends UpdateDevicesRequest {
    enable: boolean;
}

export interface AddDeviceRequest extends AppEntityRequest {
    name: string;
    udid: string;
}

export type UpdateDevicesResponseType = GetAllDevicesResponse;
export type UpdateDevicesRequestType = UpdateDevicesRequest | AddDeviceRequest | EnableDisableDevicesRequest;

// Update

export interface TryUpdateDevicesAction {
    type: DevicesUpdatable;
    payload: UpdateDevicesRequestType;
}

export interface UpdateDevicesSuccessAction {
    type: typeof UPDATE_DEVICES_REQUEST_SUCCESS;
    payload: UpdateDevicesResponseType & AppEntityRequest;
}

// Actions

export const tryUpdateDevicesRequest: (
    type: DevicesUpdatable,
    payload: UpdateDevicesRequestType,
) => TryUpdateDevicesAction = (type, payload) => {
    return {
        type,
        payload,
    };
};

export const updateDevicesSuccess: (
    response: UpdateDevicesResponseType & AppEntityRequest,
) => UpdateDevicesSuccessAction = (response) => {
    return {
        type: UPDATE_DEVICES_REQUEST_SUCCESS,
        payload: response,
    };
};
